<template>
  <div class="empty-content">
    <div
      class="image-overlay"
      v-if="showPhysicalHoleButton">
      <div class="image-overlay-content">
        <div class="image-overlay-content-text">
          <p>
            Choose the number of <strong>unique physical holes</strong> at your
            club.
          </p>
          <p>The physical holes can be reused multiple times in the guides.</p>
          <p>
            For example, if you have 9 physical holes they can be used to create
            an 18-hole guide.
          </p>
        </div>
        <img
          src="/coursedataimages/PhysicalHoleImage.png"
          width="800"
          height="400"
          alt="explaination of physical holes" />
        <div class="image-overlay-bottom">
          <button
            class="te-btn te-btn-md te-btn-primary"
            @click="hidePhysicalHoleButton()">
            Got it!
          </button>
        </div>
      </div>
    </div>
    <div class="empty-heading">
      <h1>You don’t have any physical holes set up</h1>
      <div class="te-paragraph-text-l">
        Please select setup for your club to start.
      </div>
    </div>
    <te-select-cards
      multiselect="true"
      v-bind:items="this.items"
      @select="this.selectionChanged"></te-select-cards>
    <div class="empty-help">
      <span class="tietoevry-icons-help"></span>&nbsp; You can change setup from
      “Standard holes” to “Custom” later in settings for holes.
    </div>
    <button
      :disabled="canContinue()"
      @click="$emit('submit', getSelectedId())"
      class="te-btn te-btn-md te-btn-primary">
      Continue
    </button>
  </div>
</template>

<script>
import { any } from 'vue-types';
import TeSelectCards from './components/te-select-cards.vue';

export default {
  name: 'CourseDataHolesEmptyView',
  emits: ['submit'],
  props: {
    selectedItem: {
      type: any,
    },
  },
  watch: {
    selectedItem: function (newVal, oldVal) {
      for (let i of this.items) {
        i.selected = i.id === newVal;
      }
      this.currentlySelected = newVal;
    },
  },
  data() {
    return {
      showPhysicalHoleButton: true,
      currentlySelected: this.selectedItem,
      items: [
        {
          id: 1,
          title: 'Standard setup',
          selected: this.selectedItem === 1,
          disabled: false,
          description: 'When your club has 18 physical holes.',
        },
        {
          id: 2,
          title: 'Custom setup',
          selected: this.selectedItem === 2,
          disabled: false,
          description: 'When your club have fewer or more than 18 holes.',
        },
      ],
    };
  },
  methods: {
    hidePhysicalHoleButton() {
      this.showPhysicalHoleButton = false;
    },
    canContinue() {
      return !this.items.find(i => {
        return i.id === this.currentlySelected;
      });
    },
    getSelectedId() {
      return this.currentlySelected;
    },
    selectionChanged(selection, all) {
      if (!selection[0]) {
        this.currentlySelected = 0;
      } else {
        this.currentlySelected = selection[0].id;
      }
    },
  },
  components: { TeSelectCards },
};
</script>
<style lang="scss">
.empty-content {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  justify-items: center;
  gap: 30px;
  width: 100%;
  .image-overlay {
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: 10px;
    top: 0;
    left: 0;
    height: 100vh;
    width: 100vw;
    background-color: rgba(0, 0, 0, 0.7);
    z-index: 100;
    .image-overlay-content {
      display: flex;
      gap: 10px;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      border-radius: 16px;
      background-color: #fff;
      .image-overlay-content-text {
        font-family: 'Tietoevry sans 1';
        font-weight: 100;
        color: var(--text-text-secondary, #313538);
        font-size: 18px;
        font-style: normal;
        line-height: 16px;
        padding: 30px 40px 0px 40px;
        width: 100%;
        p {
          font-weight: 300;
        }
        strong {
          font-weight: 800;
        }
      }
    }
    img {
      margin: 0px 30px 0px 30px;
    }
    .image-overlay-bottom {
      text-align: right;
      width: 100%;
      padding: 12px;
      background-color: rgba(0, 0, 0, 0.1);
    }
  }
  .empty-heading {
    display: flex;
    width: 100%;
    text-align: center;
    flex-direction: column;
    align-items: center;
    justify-items: center;
  }
  .empty-help {
    display: flex;
    justify-content: center;
    color: var(--text-text-secondary, #313538);
    font-family: 'Tietoevry sans 1';
    font-size: 10.5px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px;
  }
}
</style>
